import {AContent, AContentDTO} from "../base.content";
import {ILiveImageDTO, LiveImage} from "../../image";
import {ListItemImage} from "./list.content";

export class BaseListImage extends LiveImage {
  setOriginal(data: ILiveImageDTO) {
    this._url = data.original;
    this._isSaved = true;
  }
}

export type BaseContentItemData = {
  primaryItem: boolean;
}

export interface BaseContentItemDTO {
  primaryText: string;
  secondaryText?: string;
  avatar?: string;
}

export interface BaseContentItemParams {
  primaryText: string;
  secondaryText?: string;
  avatar?: LiveImage;
}

export class BaseContentItem {
  public readonly primaryText: string;
  public readonly secondaryText: string;
  public readonly avatar: LiveImage;

  constructor(data: BaseContentItemParams) {
    this.primaryText = data.primaryText;
    this.secondaryText = data.secondaryText;
    this.avatar = data.avatar;
  }

  public merge(data: any): this {
    let newInstance = Object.create(this);
    return Object.assign(newInstance, this, data) as this;
  }

  public toJSON(): BaseContentItemParams {
    const { primaryText, secondaryText, avatar } = this;
    return {
      primaryText,
      secondaryText,
      avatar
    }
  }
}

export interface IContentMapper {
  toDTO(data: AContent): AContentDTO;
  fromDTO(data: AContentDTO): AContent;
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/base.content.ts